/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const BrandOp: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.045 9h.137a1.91 1.91 0 011.91 1.909v2.179a1.91 1.91 0 01-1.91 1.908h-.273A1.909 1.909 0 010 13.088v-2.18C0 9.856.855 9 1.909 9h.136zM7.008 9h.137c1.054 0 1.909.855 1.909 1.909v2.179a1.91 1.91 0 01-1.91 1.908h-.273a1.91 1.91 0 01-1.909-1.908v-2.18A1.91 1.91 0 016.872 9h.136zM12.003 9h.137c1.054 0 1.909.855 1.909 1.909v2.179a1.909 1.909 0 01-1.909 1.908h-.274a1.91 1.91 0 01-1.908-1.908v-2.18A1.91 1.91 0 0111.867 9h.136zM16.999 9h.136a1.91 1.91 0 011.91 1.909v2.179a1.91 1.91 0 01-1.91 1.908h-.273a1.909 1.909 0 01-1.908-1.908v-2.18c0-1.053.854-1.908 1.908-1.908H17zM21.955 9h.136C23.145 9 24 9.855 24 10.909v2.179a1.909 1.909 0 01-1.909 1.908h-.273a1.91 1.91 0 01-1.909-1.908v-2.18A1.91 1.91 0 0121.82 9h.136z"
        fill="#F60"
      />
    </Icon>
  );
};

export default BrandOp;

BrandOp.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
